<template>
  <div class="container-fluid py-3 px-2 px-md-4">
    
      <div class="col-12">
        
          <!-- CONTENEDOR PRINCIPAL -->

            <div class="d-flex justify-content-end mt-1">
              <div class="input-group w-25 shadow-sm rounded-3">
                <span class="input-group-text bg-white border-end-0">
                  <i class="bi bi-search text-primary"></i>
                </span>

                <input type="text" class="form-control border-start-0" placeholder="Buscar por nombre..."
                  v-model="dni_busqueda" @input="onSearch" />
              </div>
            </div>

            <!-- LOADING DEL BUSCADOR -->
            <div v-if="loading" class="text-center container mt-4">
              <b-spinner variant="primary"></b-spinner>
              <p class="mt-2">Buscando…</p>
            </div>
  <div class="mt-2 ms-2 tamaño">
              (*) Solo escoger el estado de
              <strong class="text-success"> SELECCIONADO </strong> cuando estén
              terminadas todas las etapas de:<strong>
                Selección, Entrevista, Documentos y Capacitación.
              </strong>
            </div>
            <!-- TABLA -->
            <div class="table-responsive mt-2" v-if="!loading">
              <table class="table table-bordered">
                <thead>
                  <tr class="bg-solimano-table text-white text-center tamaño2 text-nowrap">
                    <th colspan="4"></th>
                    <th colspan="2">SELECCION</th>
                    <th colspan="2">ENTREVISTA</th>
                    <th colspan="2">DOCUMENTO</th>
                    <th colspan="2">CAPACITACION</th>
                    <th colspan="2">CONTRATOS</th>

                    <th colspan="5"></th>
                  </tr>

                  <tr class="bg-solimano-table text-white text-center tamaño2 text-nowrap">
                    <th>N° RQ</th>
                    <th>REF.</th>
                    <th>POSTULANTE</th>
                    <th>ESTADO</th>

                    <th>ETAPA</th>
                    <th>FEC. EJEC.</th>
                    <th>ETAPA</th>
                    <th>FEC. EJEC.</th>
                    <th>ETAPA</th>
                    <th>FEC. EJEC.</th>
                    <th>ETAPA</th>
                    <th>FEC. EJEC.</th>
                    <th>ETAPA</th>
                    <th>FEC. EJEC.</th>

                    <th><i class="bi bi-boxes fs-5"></i></th>
                    <th>FEC.INICIO CONTRATO</th>
                    <th>FEC.FIN CONTRATO</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="post in paginatedInfo" :key="post.idSolxPostulante"
                    class="tamaños text-nowrap align-middle">

                    <th>{{ post.idMaeSolicitud }}</th>

                    <td >{{ post.solfuente }}</td>

                    <td >{{ post.nombre }}</td>

                    <td class="fw-bold tamaño text-center align-middle">
                      <span :class="{
                        'text-success': post.solPosMotivo == '010',
                        'text-primary': post.solPosMotivo == '011',
                        'text-danger': post.solPosMotivo != '010' && post.solPosMotivo != '011'
                      }">
                        <i class="me-1" :class="{
                          'bi bi-check-circle-fill': post.solPosMotivo == '010',
                          'bi bi-info-circle-fill': post.solPosMotivo == '011',
                          'bi bi-x-circle-fill':
                            post.solPosMotivo != '010' && post.solPosMotivo != '011'
                        }"></i>

                        {{ post.solDesMotivo }}
                      </span>
                    </td>
                    <td>
                      <button @click="editSeleccion(post.idSolxPostulante)"
                        :class="post.solPosSeleccion ? 'btn btn-success py-1' : 'btn btn-warning py-1'">
                        <i :class="post.solPosSeleccion ? 'bi bi-check-circle' : 'bi bi-person-bounding-box'"></i>
                      </button>
                    </td>

                    <td>{{ post.solFecSelEjec.slice(0, 4) == 1900 ? '--' : post.solFecSelEjec.slice(0, 10) }}</td>

                    <td>
                      <button @click="editEntrevista(post.idSolxPostulante)"
                        :class="post.solPosEntrevista ? 'btn btn-success py-1' : 'btn btn-warning py-1'">
                        <i :class="post.solPosEntrevista ? 'bi bi-check-circle' : 'bi bi-headset'"></i>
                      </button>
                    </td>

                    <td>{{ post.solFecEntEjec.slice(0, 4) == 1900 ? '--' : post.solFecEntEjec.slice(0, 10) }}</td>

                    <td>
                      <button @click="editDocumentos(post.idSolxPostulante)"
                        :class="post.solPosDocumento ? 'btn btn-success py-1' : 'btn btn-warning py-1'">
                        <i :class="post.solPosDocumento ? 'bi bi-check-circle' : 'bi bi-folder2-open'"></i>
                      </button>
                    </td>

                    <td>{{ post.solFecDocEjec.slice(0, 4) == 1900 ? '--' : post.solFecDocEjec.slice(0, 10) }}</td>

                  

                    


                      <td>
                      <button @click="editCapacitaciones(post.idSolxPostulante)"
                        :class="post.solPosCapacitacion ? 'btn btn-success py-1' : 'btn btn-warning py-1'">
                        <i :class="post.solPosCapacitacion ? 'bi bi-check-circle' : 'bi bi-camera-reels'"></i>
                      </button>
                    </td>

                    <td>{{ post.solFecCapEjec.slice(0, 4) == 1900 ? '--' : post.solFecCapEjec.slice(0, 10) }}</td>

                    <td>
                      <button @click="editContrato(post.idSolxPostulante)"
                        :class="post.solPosContratos ? 'btn btn-success py-1' : 'btn btn-warning py-1'">
                        <i :class="post.solPosContratos ? 'bi bi-check-circle' : 'bi bi-vector-pen'"></i>
                      </button>
                    </td>

                    <td>{{ post.solFecConEjec.slice(0, 4) == 1900 ? '--' : post.solFecConEjec.slice(0, 10) }}</td>

                    <td class="d-flex">
                      <b-button v-b-modal.modal-center5
                        :class="post.solComentario ? 'btn btn-info' : 'btn btn-light border'">
                        <i class="bi bi-chat-dots"></i>
                      </b-button>

                         <button
                          @click="
                            CrearUser(
                              post.idMaePostulante,
                              post.nombre.slice(21, post.nombre.length),
                              post.posNroDocumento,
                              post.idSolxPostulante
                            )
                          "
                          :disabled="permisoVisualizador == 2 ? false : true"
                          class="btn btn-light border border-1 py-1 my-0 ms-2"
                        >
                          <i class="bi bi-person-add"></i>
                        </button>

                        <button
                          v-if="permisoVisualizador == 2"
                          class="btn btn-light ms-2 border border-1 py-1 my-0"
                          @click="mandarEstadoPostulanteXcorreo(post)"
                        >
                          <i class="bi bi-envelope-at"></i>
                        </button>
                      </td>
                    <td>
                      <input type="date" class="form-control  tamaño " v-model="post.fecIniContrato" :min="fechaMinima"
                        @change="datosIni(post)" />
                    </td>

                    <td>
                      <input type="date" class="form-control  tamaño " v-model="post.fecFinContrato" :min="fechaMinima"
                        @change="datosFin(post)" />
                    </td>

                  </tr>
                </tbody>
              </table>
             <b-modal size="lg" id="modal-center5" centered title="COMENTARIOS" body-class="p-3">
                <div class="d-flex align-items-start gap-3">

                  <!-- TEXTAREA -->
                  <b-form-textarea v-if="permisoVisualizador == 10" rows="7"
                    class="flex-grow-1 shadow-sm border-3 rounded-3 p-3 "
                    placeholder="Escribe un comentario..."></b-form-textarea>

                  <b-form-textarea v-else rows="7" class="flex-grow-1 shadow-sm border-3 rounded-3 p-3 bg-light"
                    placeholder="Escribe un comentario..." disabled></b-form-textarea>

                  <!-- BOTÓN GUARDAR -->
                  <button class="btn btn-success rounded-circle shadow-sm p-3 h-auto">
                    <i class="bi bi-save fs-4"></i>
                  </button>

                </div>
              </b-modal>

            </div>

            <!-- PAGINACIÓN -->
            <div v-if="!loading" class="d-flex justify-content-center my-3 gap-2">

              <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1" :disabled="currentPage === 1">
                <i class="bi bi-chevron-double-left"></i>
              </button>

              <button class="btn btn-outline-primary btn-sm" @click="currentPage--" :disabled="currentPage === 1">
                <i class="bi bi-chevron-left"></i>
              </button>

              <span class="fw-bold">
                Página {{ currentPage }} de {{ totalPages }}
              </span>

              <button class="btn btn-outline-primary btn-sm" @click="currentPage++"
                :disabled="currentPage === totalPages">
                <i class="bi bi-chevron-right"></i>
              </button>

              <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages"
                :disabled="currentPage === totalPages">
                <i class="bi bi-chevron-double-right"></i>
              </button>

            </div>


        </div>
     
  </div>
  
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "SolimanologTablaGestionSolicitud",

  data() {
    return {
      permisoVisualizador: "",
      info: [],
      dni_busqueda: "",
      comentarios: [],

      loading: false,
      currentPage: 1,
      pageSize: 4,

      forms: {
        IdSolxPostulante: "",
        FecIniContratos: "",
        FecFinContratos: "",
        idUsuario: ""
      },
      comentarioCorrela: "",
      acomodar: "",
      acomodare: "",
    };
  },

  async mounted() {
    let parametro = localStorage.getItem("solicitudXpostulante");
    this.forms.idUsuario = localStorage.getItem("userId");
    this.permisoVisualizador = localStorage.getItem("idPerfil");

    let response = await this.axios.get(
      "SolicitudPostulante/ObtenerPosxSol/" + parametro
    );

    this.info = response.data;

    let comentario = await this.axios.get("ParametroData/Parametro/7507");
    this.comentarios = comentario.data;
  },

  computed: {
    filteredInfo() {
      if (this.dni_busqueda.length < 3) return this.info;
      return this.info.filter(p =>
        p.nombre.toLowerCase().includes(this.dni_busqueda.toLowerCase())
      );
    },

    totalPages() {
      return Math.ceil(this.filteredInfo.length / this.pageSize) || 1;
    },

    paginatedInfo() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.filteredInfo.slice(start, start + this.pageSize);
    },

    fechaMinima() {
    const hoy = new Date();
    const año = hoy.getFullYear();
    const mes = String(hoy.getMonth() + 1).padStart(2, '0');
    const dia = String(hoy.getDate()).padStart(2, '0');
    
    return `${año}-${mes}-${dia}`; // Retorna "2026-02-17"
  }
  },

  methods: {

    onSearch() {
      this.loading = true;
      this.currentPage = 1;

      clearTimeout(this._typingTimer);

      this._typingTimer = setTimeout(() => {
        this.loading = false;
      }, 400);
    },

    async getAttributes() {
      let parametro = localStorage.getItem("solicitudXpostulante");
      let response = await this.axios.get(
        "SolicitudPostulante/ObtenerPosxSol/" + parametro
      );
      this.info = response.data;
    },

    CrearUser(post) {
      const user = {
        idPostulante: post.idMaePostulante,
      };

      this.axios.post("UsuarioPostulante/Registrar", user).then(() => {
        this.getAttributes();
      });
    },

    datosIni(post) {
      const payload = {
        idSolxPostulante: post.idSolxPostulante,
        idUsuario: this.forms.idUsuario,
        fecIniContratos: post.fecIniContrato,
        fecFinContratos: "1900-01-01",
      };

      this.axios.put("SolicitudPostulante/ModificarFecContrato", payload)
        .then(r => {
          if (r.data) {
            Swal.fire({
              icon: "success",
              title: "¡Fecha de inicio actualizada!",
              timer: 1000,
              showConfirmButton: false,
            });
          }
        });
    },

    datosFin(post) {
      const payload = {
        idSolxPostulante: post.idSolxPostulante,
        idUsuario: this.forms.idUsuario,
        fecIniContratos: "1900-01-01",
        fecFinContratos: post.fecFinContrato,
      };

      this.axios.put("SolicitudPostulante/ModificarFecContrato", payload)
        .then(r => {
          if (r.data) {
            Swal.fire({
              icon: "success",
              title: "¡Fecha fin actualizada!",
              timer: 1000,
              showConfirmButton: false,
            });
          }
        });
    },

    editSeleccion(id) {
      this.$router.push("/contratosEstadoSeleccion/" + id);
      window.scrollTo(0, 0);
    },

    editEntrevista(id) {
      this.$router.push("/datosEntrevista/" + id);
      window.scrollTo(0, 0);
    },

    editDocumentos(id) {
      this.$router.push("/datosDocmuentos/" + id);
      window.scrollTo(0, 0);
    },

    editCapacitaciones(id) {
      this.$router.push("/datosCapacitaciones/" + id);
      window.scrollTo(0, 0);
    },

    editContrato(id) {
      this.$router.push("/contratosEstadoContrat/" + id);
    },
  },
};
</script>


<style scoped>
.tabla {
  background: rgb(24, 147, 196);
}

.bg-solimano {
  background: #0080c8;
}

.agrandar {
  width: 280px;
}

.tamaño {
  font-size: 0.65rem;
}


.reducirTamaño {
  font-size: 0.65rem;
}


.tamaños {
  font-size: 0.65rem;
}

.tamaño2 {
  font-size: 0.65rem;
  font-weight: 800;
}

.titulo {
  color: #0080c8;
  text-decoration: underline;
}

.bg-solimano-table {
  background: #0080c8;
}

.btn-solimano {
  background: #0080c8;
}
</style>
